module.exports = __webpack_public_path__ + "static/media/banner-placeholder.d56c1d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-placeholder.jpg
// module id = 224
// module chunks = 0